import { createSlice } from '@reduxjs/toolkit'

export const nameSlice = createSlice({
  name: 'name',
  initialState: {
    value: 'fejkwlfje'
  },
  reducers: {
    updateName: (state, action) => {
      state.value = action.payload;
    }
  }
})

export const { updateName } = nameSlice.actions

export const selectName = (state) => state.name.value

export default nameSlice.reducer